/**
 * Extract a human-readable message from an unknown error. Supabase/PostgREST
 * errors are PLAIN OBJECTS ({ message, code, details, hint }), not Error
 * instances, so `String(e)` on them yields "[object Object]". This pulls the
 * real message (falling back through the object's fields) so a raised RPC
 * exception surfaces its text to the user instead of "[object Object]".
 */
export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (e && typeof e === 'object') {
    const o = e as Record<string, unknown>;
    const m = o.message ?? o.error_description ?? o.details ?? o.hint;
    if (typeof m === 'string' && m.trim()) return m;
    try {
      return JSON.stringify(o);
    } catch {
      return String(e);
    }
  }
  return String(e);
}
